<template >
    <div class=""  v-if="pt150ListSize !=null " :style="htmlAlign" v-cloak>
        <template v-if="pt150Init.bannerInfo && pt150Init.bannerInfo.NAIYO_KBN == '3'">
            <!-- リンク先区分（バナーのときだけ使用 1:商品CD 2:URL -->
            <!-- 1：商品CDの場合(商品CDのとき、商品詳細ページへリンクさせる) -->
            <a v-if="pt150Init.bannerInfo.LINK_KBN == '1'" @click="selectLink(pt150Init.bannerInfo.LINK_ITEM_NO)">
                <img :src="pt150Init.bannerInfo.BANNER_IMG_URL" @error="getErrImage" :alt='pt150Init.bannerInfo.ALT_TAG'>
            </a>
            <!-- 2：URLの場合(リンク先URLのとき、指定のURLへリンクさせる)%> -->
            <a v-else :href='pt150Init.bannerInfo.LINK_URL'>
                <img :src="pt150Init.bannerInfo.BANER_UUID" @error="getErrImage" :alt='pt150Init.bannerInfo.ALT_TAG'>
                <!-- TODO: Change the appropriate image path -->
            </a>
        </template>
        <template v-else >
            <div v-html="htmlTxt">
            </div>
        </template>
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
export default {
    /* 
    * Name of component
    */
    name: "detailHtmlParts",
    /* 
    * Get data from parent component
    */
    props: {
        partsNo: {
            type: Number
        },
        ptInitData: {
            type: Object,
            default: null,
        },
        htmlText: {
			type: String,
			default: ''
		},
    },
    data() {
        return {
            pt150ListSize:null,
            pt150Init:{},
            listIdErr:[],
            pt150ReqModel:{
              partsNo: null
            },
            htmlTxt:null,
            scriptTxt: null,
            scriptUrl: null,
            htmlAlign:null,
            site: ""
        }
    },
    
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        // eslint-disable-next-line
        _this.pt150ReqModel.partsNo = _this.partsNo;

        if(_this.htmlText){
            _this.pt150ListSize = _this.htmlText
            _this.htmlTxt = _this.htmlText;
            return
        }
        if (_this.ptInitData){
            _this.pt150Init = _this.ptInitData;
            _this.pt150ListSize = _this.pt150Init.bannerInfo;
            _this.htmlTxt = _this.ptInitData.html || _this.ptInitData.HTML_TXT;
            _this.scriptTxt = _this.ptInitData.scriptTxt;
            _this.scriptUrl = _this.ptInitData.scriptUrl;
            if(_this.pt150ListSize !=null) {
                if(_this.pt150Init.bannerInfo.NAIYO_KBN === '3'){
                    //バナーではない(HTML)の場合
                    _this.htmlAlign = "align: left;"
                }
            }

            //insert script
            if(_this.scriptTxt && _this.scriptTxt != "") {
                var script = document.createElement('script');
                script.appendChild(document.createTextNode(_this.scriptTxt));
                document.body.appendChild(script);
            }
            
            if(_this.scriptUrl && _this.scriptUrl != "") {
                var lstScriptUrl = _this.scriptUrl.split(";");
                var src = "";
                for (var i = 0; i < lstScriptUrl.length; i++) {
                    src = lstScriptUrl[i];
                    if(src != "") {
                        var scriptUrl = document.createElement('script'); 
                        scriptUrl.setAttribute('src',src);
                        document.body.appendChild(scriptUrl);
                    }
                }
            }
        }
    },

    methods: {
        selectLink: function(itemNo) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG030, params: {pageNo: 3, sItemNo : itemNo}});
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
    }
}
</script>
